import * as ActionTypes from '../../Constants/actionTypes';
import { API_ALERT } from '../../Constants/apiUrls'; // Add your API URL here
import { fetchAlertMessage } from '../../Constants/apiService';



export const fetchAlert = () => async (dispatch, getState) => {
    dispatch({ type: ActionTypes.FETCH_ALERT_REQUEST });
    const state = getState();
    const token = state.auth.accessToken;
    try {
        const data = await fetchAlertMessage(token);
        dispatch({ type: ActionTypes.FETCH_ALERT_SUCCESS, payload: data });
    } catch (error) {
        let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
        dispatch({ type: ActionTypes.FETCH_ALERT_FAILURE ,payload: errorMessage});
    }
};
